<template>
  <div class="container">
    <div class="autoselect-options-container">
      <div v-if="showDropdown" class="autoselect-options">
        <div v-for="option in filteredOptions" v-bind:key="option.label">
          <span @click="onOptionClick(option.value)" :title="option.label">{{
            option.label
          }}</span>
        </div>
      </div>
      <img
        class="caret"
        v-if="showCaret"
        :src="caret"
        @click="toggleDropdown"
        alt="seleccion-area-telefono"
      />
    </div>
    <text-input
      ref="textInput"
      class="text-input"
      :hint="placeholder"
      :label="label"
      :value="selectedValue"
      :required="required"
      :subhint="subhint"
      :validationError="validationError"
      pattern="[0-9]*"
      :inputmode="inputMode"
      @input="onInput"
      @onFocus="onFocus"
      @onBlur="onBlur"
      @click="$emit('click')"
    />
  </div>
</template>

<script>
import TextInput from "@/components/core/TextInput";
export default {
  name: "SelectAutocomplete",
  components: { TextInput },
  props: [
    "placeholder",
    "label",
    "value",
    "subhint",
    "validationError",
    "items",
    "inputMode"
  ],
  data() {
    return {
      focused: false,
      forceShowDropdown: false,
      caret: require("@/assets/img/1x/arrow-simple-down.svg")
    };
  },
  computed: {
    options() {
      // Parsear los items
      return this.items.map(item => {
        return {
          label: item.label ? item.label : item,
          value: item.value ? item.value : item
        };
      });
    },
    showDropdown() {
      return (
        this.forceShowDropdown ||
        (this.focused && this.filteredOptions.length !== this.options.length)
      );
    },
    showCaret() {
      return !this.value;
    },
    filteredOptions() {
      // Obtener el value y quitar espacio
      let inputValue =
        this.value && this.value !== "undefined"
          ? (this.value + "").trim()
          : "";
      inputValue = this.filterLeadingZeros(inputValue);

      // Filtrar los items
      return !inputValue
        ? this.options
        : this.options.filter(item => {
            let inputIsInOption =
              inputValue &&
              (item.value.toLowerCase() + item.label.toLowerCase()).indexOf(
                inputValue.toLowerCase()
              ) !== -1;

            return inputValue && inputIsInOption;
          });
    },
    selectedValue() {
      if (!this.focused) {
        // Encontrar el object para el option seleccionado
        let option = this.options.find(val => {
          return val.value === this.value;
        });

        // Devolver el label si lo tengo en el listado de options
        return option && option.label ? option.label : this.value;
      } else {
        // Si el input tiene foco, muestro solo su value
        return this.value;
      }
    }
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      setTimeout(() => {
        // Dar tiempo al select a poner el value
        this.focused = false;
        this.$emit("input", this.filterLeadingZeros(this.value));
      }, 230);
    },
    onOptionClick(val) {
      this.$emit("input", val);
      this.forceShowDropdown = false;
    },
    toggleDropdown() {
      this.forceShowDropdown = !this.forceShowDropdown;
      if (this.forceShowDropdown) {
        this.$refs.textInput._focus();
      }
    },
    filterLeadingZeros(val) {
      // Quitar los ceros del comienzo del valor
      // TODO: Mover fuera de este componente genérico
      val = val ? val + "" : "";
      while (val.length > 0 && val.charAt(0) == 0) {
        val = val.substr(1);
      }
      return val;
    }
  }
};
</script>

<style scoped>
.autoselect-options-container {
  position: relative;
}

.autoselect-options-container .caret {
  position: absolute;
  right: 0;
  top: 0;
  /* El borde es para agrandar el area clickeable */
  border-right: 16px solid transparent;
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
  cursor: pointer;
  z-index: 1000;
}

.autoselect-options {
  position: absolute;
  z-index: 100;
  left: 0;
  right: 0;
  top: 56px; /* Alto inputs */
  background: white;
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.2);
}

.autoselect-options span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 16px 0;
  border-bottom: 1px solid #bdbdbd;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.autoselect-options div {
  padding: 0 16px;
}
.autoselect-options div:hover {
  background-color: #eeeeee;
}

.autoselect-options div:last-child span {
  border-bottom: 0;
}

.autoselect-options span:hover {
  color: #000;
}
</style>
